import getCategories from './util/getCategories'
import getSkincareCollections from './util/getSkincareCollections'


const getNavStructureDefault = ({ root, structure }) => {
  const isSkincare = root === 'skincare'

  return structure.reduce((newStructure, { pageTitle, url, name, children, productsQuery: { gender } = {} }, index) => {
    const categories = getCategories({ routes: children })
    const seeAllItem = {
      title: pageTitle,
      to: url,
      name,
      bold: isSkincare,
      dataTestId: name,
    }

    if (isSkincare) {
      const collectionsItem = getSkincareCollections({ gender })

      if (index) {
        newStructure.push({ isLine: true })
      }

      newStructure.push(
        seeAllItem,
        collectionsItem
      )
    }
    else {
      newStructure.push(seeAllItem)
    }

    newStructure.push(...categories)

    return newStructure
  }, [])
}


export default getNavStructureDefault
